import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade show",
  id: "kt_modal_event_mecanico",
  "aria-modal": "true",
  role: "dialog",
  ref: "newTargetModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Outros eventos", -1)
const _hoisted_6 = { class: "modal-body py-6 px-lg-10" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Tipo de evento", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Técnico(s)", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Data da tarefa", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "row"
}
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, " Período ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_23 = {
  key: 2,
  class: "row row-cols-lg-2 g-10"
}
const _hoisted_24 = { class: "col" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, " Horário inicial ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_27 = { class: "col" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, " Horário final ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_30 = {
  key: 3,
  class: "fv-row"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Descrição", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_33 = { class: "modal-footer flex-end px-lg-10" }
const _hoisted_34 = ["data-kt-indicator"]
const _hoisted_35 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_36 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_37 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          class: "form fv-plugins-bootstrap5 fv-plugins-framework",
          id: "kt_modal_add_event_form",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.targetData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
                "aria-label": "Close"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_form_item, { prop: "taskType" }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetData.taskType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.taskType) = $event)),
                        "value-key": "TIPO",
                        filterable: "",
                        "reserve-keyword": "",
                        clearable: true,
                        placeholder: "Selecione",
                        "no-match-text": "Nenhum tipo foi encontrado",
                        "no-data-text": "Nenhum tipo foi encontrado"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipoOptions, (tipo, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: tipo.text,
                              value: tipo.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_form_item, { prop: "tecnico" }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetData.tecnico,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.tecnico) = $event)),
                        "value-key": "TECNICO",
                        filterable: "",
                        multiple: "",
                        clearable: true,
                        placeholder: "Selecione",
                        "no-match-text": "Nenhum técnico foi encontrado",
                        "no-data-text": "Nenhum técnico foi encontrado"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tecnicoOptions, (tipo, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: tipo.text,
                              value: tipo.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.targetData.taskType == 12)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_el_form_item, { prop: "taskDate" }, {
                          default: _withCtx(() => [
                            _hoisted_17,
                            _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: _ctx.targetData.taskDate,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.taskDate) = $event)),
                                  type: "text",
                                  name: "eventStartDate",
                                  format: "DD/MM/YYYY"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["locale"]),
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.targetData.taskType == 9 || _ctx.targetData.taskType == 10 || _ctx.targetData.taskType == 11)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "datePicker" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                type: "daterange",
                                placeholder: "Selecione uma data",
                                name: "eventName",
                                format: "DD/MM/YYYY",
                                clearable: !_ctx.lastEmitIsNull,
                                modelValue: _ctx.targetData.datePicker,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetData.datePicker) = $event))
                              }, null, 8, ["clearable", "modelValue"]),
                              _hoisted_22
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["locale"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.targetData.taskType == 9 || _ctx.targetData.taskType == 12)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_el_form_item, { prop: "taskStartHour" }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createVNode(_component_el_time_select, {
                            modelValue: _ctx.targetData.taskStartHour,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.targetData.taskStartHour) = $event)),
                            start: _ctx.horarios.horaAbertura,
                            step: "00:15",
                            end: _ctx.horarios.horaFechamento,
                            placeholder: "Selecione o horário",
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.verificaHorarioInicial()))
                          }, null, 8, ["modelValue", "start", "end"]),
                          _hoisted_26
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_el_form_item, { prop: "taskEndHour" }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _createVNode(_component_el_time_select, {
                            disabled: !_ctx.targetData.taskStartHour,
                            modelValue: _ctx.targetData.taskEndHour,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.targetData.taskEndHour) = $event)),
                            start: _ctx.initialTaskEndHour,
                            step: "00:15",
                            end: _ctx.horarios.horaFechamento,
                            placeholder: "Selecione o horário"
                          }, null, 8, ["disabled", "modelValue", "start", "end"]),
                          _hoisted_29
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.targetData.taskType == 12)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createVNode(_component_el_form_item, { prop: "detalhes" }, {
                      default: _withCtx(() => [
                        _hoisted_31,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.targetData.detalhes,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.targetData.detalhes) = $event)),
                          type: "text",
                          name: "eventName"
                        }, null, 8, ["modelValue"]),
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-sm btn-flex background_btn_1_opct text-white",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                      _createTextVNode(" Adicionar "),
                      _createElementVNode("span", _hoisted_36, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                      _createTextVNode(" Adicionando tarefa... "),
                      _hoisted_38
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_34)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}